import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import Heading from 'components/universal/heading';
import { useTopic } from 'hooks/useTopic';

import handsImg from 'assets/images/elearning/hand-care/hands.png';
import jewelryImg from 'assets/images/elearning/preparing-your-hands-to-work/bizuteria.png';
import artificialNailsImg from 'assets/images/elearning/preparing-your-hands-to-work/sztuczne-paznokcie.png';
import { Carousel } from 'components/universal/carousel';
import { useTranslation } from 'react-i18next';
import cls from './preparing-your-hands-to-work.module.scss';

export const PreparingYourHandsToWork = () => {
    const { t } = useTranslation('', {
        keyPrefix:
            'elearning.handHygiene.handDisinfectionAndWashing.preparingYourHandsToWork',
    });
    const { tasks, correctAnswer, isAnswerChecked } = useTopic();

    
    const carousel1 = [
        {
            original: handsImg,
        },
    ];
    const carousel2 = [
        {
            original: artificialNailsImg,
        },
    ];
    const carousel3 = [
        {
            original: jewelryImg,
        },
    ];

    const taskFirstPart = tasks.slice(0, 1);
    const taskSecondPart = tasks.slice(1);

    return (
        <div className="container">
            <Heading className="mb-5" headingLevel="h1" headingStyle="h2a">
                {t('title')}
            </Heading>
            
            <Carousel items={carousel1} showIndex={false} showNav={false} title={t('title1')} />

            <div className="space"></div>

            <TasksGenerator
                tasks={taskFirstPart}
                isChecked={isAnswerChecked}
                correctAnswer={correctAnswer}
                isQuiz={false}
            />

            <div className={cls.shadow}>
                <Carousel className={cls.customCarusel} items={carousel2} showIndex={false} showNav={false} title={t('title2')} description={t('desc1')} subscription={t('desc3')} />
                <Carousel className={cls.customCaruse2} items={carousel3} showIndex={false} showNav={false} title={t('title3')} description={t('desc2')} subscription={t('desc4')}/>
            </div>

            <div className="space"></div>

            <TasksGenerator
                tasks={taskSecondPart}
                isChecked={isAnswerChecked}
                correctAnswer={correctAnswer}
                isQuiz={false}
            />
        </div>
    );
};
